import React from 'react';
import Input from '../../input';

const AuthInputs = props => {
  const {
    tab,
    phone,
    password,
    errorPhone,
    errorPassword,
    getCode,
    changeState,
    isPopup,
    placeholder
  } = props;

  const inputPhone = (
    <Input
      accent
      center={!isPopup}
      label="Номер телефона"
      name="phone"
      placeholder="Введите номер"
      phone
      value={phone}
      error={errorPhone}
      onFocus={() => changeState({ errorPhone: false })}
      onChange={val => changeState({ phone: val, getCode: false })}
    />
  );
  const inputPassword = (
    <Input
      accent
      center={!isPopup}
      label="Пароль"
      name="password"
      password
      placeholder="Введите пароль"
      value={password}
      error={errorPassword}
      onFocus={() => changeState({ errorPassword: false })}
      onChange={val => changeState({ password: val })}
    />
  );
  const inputCode = (
    <Input
      accent
      center
      label="ВВЕДИТЕ КОД"
      name="password"
      placeholder={placeholder}
      value={password}
      error={errorPassword}
      onFocus={() => changeState({ errorPassword: false })}
      onChange={val => changeState({ password: val })}
    />
  );

  switch (tab) {
    case 'auth':
      return (
        <div className="login-form__inputs">
          {inputPhone}
          {errorPhone ? null : inputPassword}
        </div>
      );

    case 'reg':
    case 'forget':
      return (
        <div className="login-form__inputs">
          {inputPhone}
          {getCode ? inputCode : null}
        </div>
      );

    default:
      return null;
  }
};

export default AuthInputs;
